import { fg } from '@atlassian/jira-feature-gating';
import { TIME_ESTIMATE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';
import type { TransformedTimeTrackingField } from '../types.tsx';

const getStringValue: StringValue<TransformedTimeTrackingField> = (field) =>
	fg('list_view_small_bulk_copy_fixes')
		? field.value?.timeAsString || ''
		: String(field.value?.timeInSeconds || '');

export const timeTrackingStringValueHandler = {
	[TIME_ESTIMATE_TYPE]: getStringValue,
};
